import React, { useEffect } from "react";
import { trackFormValidationError } from "./../util/analytics";

function TextField(props) {
  const {
    error,
    type = "text",
    size = "md",
    label,
    className,
    inputRef,
    autoComplete,
    ...inputProps
  } = props;

  // Track validation errors when they appear
  useEffect(() => {
    if (error && error.message && inputProps.name) {
      // Extract form name from the input id or name
      const formName = inputProps.id?.split('-')[0] || 'unknown';
      trackFormValidationError(formName, inputProps.name, error.message);
    }
  }, [error, inputProps.name, inputProps.id]);

  const classes = {
    base: "block border placeholder-gray-400 z-10 w-full rounded active:z-10 focus:z-10 -mr-px border-gray-200 focus:border-blue-500 focus:ring focus:ring-blue-500 focus:ring-opacity-50",
    size: {
      sm: "py-2 leading-5",
      md: "px-4 py-3 leading-6",
      lg: "",
    },
  };

  return (
    <div className={"w-full" + (className ? ` ${className}` : "")}>
      {label && (
        <label className="block mb-1 font-medium" htmlFor={props.id}>
          {label}
        </label>
      )}

      {type === "textarea" && (
        <textarea
          className={`${classes.base} ${classes.size[size]}`}
          ref={inputRef}
          {...inputProps}
        />
      )}

      {type !== "textarea" && (
        <input
          className={`${classes.base} ${classes.size[size]}`}
          ref={inputRef}
          type={type}
          autoComplete={autoComplete}
          {...inputProps}
        />
      )}

      {error && (
        <p className="text-sm text-left text-red-600 mt-1">{error.message}</p>
      )}
    </div>
  );
}

export default TextField;